import { useSelector } from 'react-redux';
import { formatCoordinate } from '@/lib/coordinates';

export default function useCoordinateFormat() {
  const user = useSelector((state) => state.session.user);
  const format = user?.attributes?.coordinateFormat || 'decimal';
  return (lat, lng) => formatCoordinate(lat, lng, format);
}
